import { UseCasePage } from '@/components/marketing/use-case-page'

export function UseCasesResearchersPage() {
  return (
    <UseCasePage
      contentKey="useCasesResearchers"
      path="/use-cases/researchers"
      relatedKeys={['useCasesStudents', 'whatIsKnowledgeGraph', 'comparePerplexity']}
    />
  )
}
